module.exports = __webpack_public_path__ + "07_mustache_silver.584362c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/07_mustache_silver.png
// module id = lAl4
// module chunks = 0